import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import EachWayPlaceTerms from '@swf/sports/components/EachWayPlaceTerms/EachWayPlaceTerms';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type { EventTypeId } from '@swf/sports/types/eventType';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import SelectionList from '../../components/SelectionList/SelectionList';

import { TXTWCL_All_N0_Markets } from './EventOutright.messages.json';
import styles from './EventOutright.scss';

const MAX_RUNNERS_TO_DISPLAY = 5;

export const EventOutright: MarketTemplateComponent<SingleMarketTemplateProps> = ({ marketId }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));
  const event = useSelector((state: RootState) => widgetSelect.event(state, market?.eventId ?? -1));
  const competition = useSelector((state: RootState) =>
    widgetSelect.competition(state, market?.competitionId ?? -1)
  );
  const eventType = useSelector((state: RootState) =>
    widgetSelect.eventType(
      state,
      (market?.eventTypeId as EventTypeId | undefined) ?? (-1 as EventTypeId)
    )
  );

  if (!market) return null;

  return (
    <li data-testid="event">
      <EachWayPlaceTerms placeTerms={market.placeTerms} variant="long" className={styles.eachWay} />
      <SelectionList market={market}>
        {market.runners.slice(0, MAX_RUNNERS_TO_DISPLAY).map((runner) => (
          <SelectionList.Item key={runner.selectionId} runner={runner} />
        ))}
        {market.runners.length > MAX_RUNNERS_TO_DISPLAY && (
          <li className={styles.viewAllWrapper}>
            <Link
              className={styles.viewAll}
              alias="sportsCompetitionOutrights"
              values={{
                eventTypeSlug: eventType.eventTypeSlug,
                eventTypeId: market.eventTypeId,
                competitionSlug: competition.competitionSlug,
                competitionId: market.competitionId,
                eventSlug: event.eventSlug,
                eventId: market.eventTypeId
              }}
            >
              <Translation {...TXTWCL_All_N0_Markets} values={{ 0: competition.competitionName }} />
              <Icon icon={ChevronMediumDown} size="sm" />
            </Link>
          </li>
        )}
      </SelectionList>
    </li>
  );
};

EventOutright.marketTemplateType = 'EVENT';

export default EventOutright;
